import React from 'react';
import IconButton, {
  IconButtonProps,
} from '~components/_common/IconButton/IconButton';

import { useIntl } from 'react-intl';

export const IconPopup: React.FC<
  { headerId: string; messageId: string } & IconButtonProps
> = ({ headerId, messageId, ...rest }) => {
  const intl = useIntl();

  const ToolTip = () => (
    <div
      style={{ whiteSpace: 'pre-line', maxHeight: '33vh', overflow: 'auto' }}>
      <h3 style={{ color: 'white' }}>{intl.formatMessage({ id: headerId })}</h3>
      <p>{intl.formatMessage({ id: messageId })}</p>
    </div>
  );

  return (
    <IconButton
      icon={['far', 'info-circle']}
      containerStyle={{
        marginLeft: 0,
        color: '#7a829b',
      }}
      backgroundOff
      tooltip={<ToolTip />}
      widthTooltip="300px"
      {...rest}
    />
  );
};
